import { useRouter } from 'next/router';

export type ProductFilters = {
  divisi_code: string;
  storage_code: string;
  sort_by_code: string;
  category_lv1: string;
  category_lv2: string;
  category_lv3: string;
  search_query: string;
  page: number;
  size: number;
  product_id: string | null;
};

export function getProductFilters(
  query: Record<string, string | string[] | undefined>
) {
  // Used for filtering products
  const searchKeywordParam = query?.['keyword'] as string;
  const filterParamByDivison = query?.['division'] as string;
  const filterParamByStorage = query?.['storage'] as string;
  const filterParamByCategory1 = query?.['cat1'] as string;
  const filterParamByCategory2 = query?.['cat2'] as string;
  const filterParamByCategory3 = query?.['cat3'] as string;
  const filterParamBySortBy = query?.['sortby'] as string;

  const page = +(query?.['page'] as string) || 1;
  const size = +(query?.['size'] as string) || 25;

  const product_id = (query?.['productId'] as string) || null;

  return {
    divisi_code: filterParamByDivison,
    storage_code: filterParamByStorage,
    sort_by_code: filterParamBySortBy,
    category_lv1: filterParamByCategory1,
    category_lv2: filterParamByCategory2,
    category_lv3: filterParamByCategory3,
    search_query: searchKeywordParam,
    page: page,
    size: size,
    product_id,
  };
}

export function useProductFilters(): ProductFilters {
  const router = useRouter();
  return getProductFilters(router.query);
}
